export const home = '/';
export const unregistered = '*';
